module.exports = __webpack_public_path__ + "static/media/destination_image_2.0c74ff12.webp";